import { render } from "./PointsBanner.vue?vue&type=template&id=2b10d772&scoped=true"
import script from "./PointsBanner.vue?vue&type=script&lang=js"
export * from "./PointsBanner.vue?vue&type=script&lang=js"

import "./PointsBanner.vue?vue&type=style&index=0&id=2b10d772&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b10d772"]])

export default __exports__